<div class="my-2">
    <!-- <app-single-input-filter *ngIf="customerMappingData && customerMappingData.data"
  [tableFilters]="customerMappingData && customerMappingData.data" (selectedFilter)="onSelectedFilter($event)">
</app-single-input-filter> -->

    @if (customerMappingData && customerMappingData.data) {
    <app-customer-mapping-multiple-input-filter [tableFilters]="customerMappingData.data.mappingFilters"
        (selectedFilter)="onSelectedFilter($event)">
    </app-customer-mapping-multiple-input-filter>
    }
</div>
<div class="table-container mat-elevation-z6">
    <mat-paginator [pageSizeOptions]="[100, 25, 10]" class="mat-mdc-paginator classic-paginator" [length]="length"></mat-paginator>
    @if (customerMappingData && customerMappingData.data) {
    <div>
        <div class="button-container">
            <button mat-stroked-button (click)="createDialog()">Create new</button>
        </div>
        @for (row of customerMappingData.data.customerMappingRows; track row) {
        <div class="mapping-container">
            <!-- <div fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="flex-start">
          <mat-card class="mapping-card"> -->
            <div class="card-wrapper">
                <mat-card class="mapping-card" appearance="outlined">
                    <mat-card-header>
                        <mat-card-title>{{row.name}}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <!-- <div fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="flex-start">
                  <div fxFlex="0 1 calc(50% - 20px)"> -->
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div>
                                    <h4>{{row.clientMappingName}}</h4>
                                </div>
                                @for (mappingRow of row.clientMapping; track mappingRow) {
                                <div class="row mb-1">
                                    <div class="col-4">
                                        <span class="property-header">{{mappingRow.displayName}}</span>
                                    </div>
                                    <div class="col-8">
                                        <span>{{mappingRow.value}}</span>
                                    </div>
                                </div>
                                }
                            </div>
                            <div class="col-12 col-md-6">
                                <div>
                                    <h4>{{row.rentokilMappingName}}</h4>
                                </div>
                                @for (mapping of processRentokilMapping(row.rentokilMapping); track mapping) {
                                <div class="row mb-1">
                                    <div class="col-4">
                                        <span class="property-header" [matTooltip]="mapping.toolTip">{{mapping.displayName}}</span>
                                    </div>
                                    <div class="col-8">
                                        <span>{{mapping.value}}</span>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions>
                        <div class="actions-container">
                            <div class="action-left">
                                <button mat-stroked-button (click)="editDialog(row)">Edit</button>
                                <button mat-stroked-button (click)="delete(row)">Delete</button>
                            </div>
                            <div class="action-right">
                                <span class="modified-date">Modified date(UTC): {{row.modifiedDate}}</span>
                            </div>
                        </div>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
        }
    </div>
    }
</div>
@if (isLoadingResults) {
<div class="loading-shade">
    @if (isLoadingResults) {
    <mat-spinner></mat-spinner>
    }
</div>
}